<template>
  <div class="blog-wrapper">
    <div class="blog">
    <h1 style="text-align: center;">:3c</h1>
      <!-- <h1>>:3</h1>
      <p>A direct look into my mind</p>

      <h3>May 5, 2025</h3>
      <p>"Penis."</p> -->
<!-- 
      <h3>May 5, 2025</h3>
      <p>"What else is there to say?"</p>
      <p>- T3ch</p>

      <h3>Jabberwocky</h3>
      <h4>Lewis Carroll</h4>
      <pre>
      ’Twas brillig, and the slithy toves
            Did gyre and gimble in the wabe:
      All mimsy were the borogoves,
            And the mome raths outgrabe.

      “Beware the Jabberwock, my son!
            The jaws that bite, the claws that catch!
      Beware the Jubjub bird, and shun
            The frumious Bandersnatch!”

      He took his vorpal sword in hand;
            Long time the manxome foe he sought—
      So rested he by the Tumtum tree
            And stood awhile in thought.

      And, as in uffish thought he stood,
            The Jabberwock, with eyes of flame,
      Came whiffling through the tulgey wood,
            And burbled as it came!

      One, two! One, two! And through and through
            The vorpal blade went snicker-snack!
      He left it dead, and with its head
            He went galumphing back.

      “And hast thou slain the Jabberwock?
            Come to my arms, my beamish boy!
      O frabjous day! Callooh! Callay!”
            He chortled in his joy.

      ’Twas brillig, and the slithy toves
            Did gyre and gimble in the wabe:
      All mimsy were the borogoves,
            And the mome raths outgrabe.
      </pre> -->
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
.blog-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: black;
  height: 100vh;
  width: 100vw;
}

.blog {
  width: 375px;
  height: 667px;
  background-color: black;
  color: white;
  padding: 1rem;
  box-sizing: border-box;
  overflow-y: scroll; /* ensure it's scrollable */
  scrollbar-width: none; /* Firefox */
  font-size: 1.1rem;
}

.blog::-webkit-scrollbar {
  display: none; /* Chrome, Safari */
}

h1, h3 {
  color: #d145a7;
}

p {
  margin: 0.5rem 0;
}

pre {
  white-space: pre-wrap;
  font-family: serif;
  line-height: 1.5;
  margin: 1rem 0;
}
</style>

